
$( document ).ready(function() {
    // On déplace les modals dans une sections dédié en fin de page (en dehors du flux du positionnement des lignes de contenu)
    // ainsi les modals pourront bien s'afficher par dessus les contenus sans conflit de z-index
    $('body').append('<div class="modal-injection-wrapper page_row" style="height:0;"><div class="moduleTemplate" id="modal-injection-point"></div></div>');
    $('#page_header .modal, #content_container .modal, #page_footer .modal').each(function(){
        $('#modal-injection-point').append(this);
    })

    // correction de dimension des panneaux plein écran (.fullscreen_content_panel)
    // si on est sur une page en mode iframe l'iframe doit prendre en compte la hauteur du #page_header
    if(1*$('body').data('page_iframe')>0)
    {
        $('body').css('overflow','hidden');
        $('.fullscreen_content_panel').css('height','calc(100vh - '+Math.ceil($('#page_header').outerHeight())+'px)');
    }
    else
    {
        $('.fullscreen_content_panel').css('height','100vh');
    }
});

// MISC
$.fn.removeClassRegExp = function (regexp) {
    if(regexp && (typeof regexp==='string' || typeof regexp==='object')) {
        regexp = typeof regexp === 'string' ? regexp = new RegExp(regexp) : regexp;
        $(this).each(function () {
            $(this).removeClass(function(i,c) {
                var classes = [];
                $.each(c.split(' '), function(i,c) {
                    if(regexp.test(c)) { classes.push(c); }
                });
                return classes.join(' ');
            });
        });
    }
    return this;
};

window.viewport = function() {
    var e = window, a = 'inner';
    if (!('innerWidth' in window )) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
}